module.exports = __webpack_public_path__ + "static/media/contactusicon.18fc24b1.svg";